'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ../~/intl-messageformat-parser/index.js
// module id = 181
// module chunks = 0 1